import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (t) => {
    lenis.raf(t);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollTo(target) {
  if (lenis) lenis.scrollTo(target, { offset: -72, duration: 1.2 });
  else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
}
